import React, { useState, useEffect } from "react";
import HeaderAdmin from "../../Components/HeaderAdmin/Header";
import CameraModal from "./CameraModal";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Form } from "react-bootstrap";

const Camera = () => {
  const [showModal, setShowModal] = useState(false);
  const [photoInBox, setPhotoInBox] = useState([null, null, null]); // Array to track images for 3 boxes
  const [activeIronIndex, setActiveIronIndex] = useState(null); // Index of the iron being worked on

  const handleOpenModal = (index) => {
    setActiveIronIndex(index);
    setShowModal(true);
  };



  const handleCloseModal = () => setShowModal(false);

  // Function to update the specific photo box with the captured image
  const updatePhotoInBox = (imageSrc) => {
    if (activeIronIndex !== null) {
      const updatedPhotos = [...photoInBox];
      updatedPhotos[activeIronIndex] = imageSrc; // Update the clicked iron's photo
      setPhotoInBox(updatedPhotos);
      handleCloseModal(); // Close the modal
    }
  };


  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  const handleResize = () => {
    // setWidth(window.innerWidth);

    // Get all divs with the class name 'drop_box'
    const squareDivs = document.querySelectorAll('.drop_box');

    squareDivs.forEach((squareDiv) => {
      // Get the width of each div
      const divWidth = squareDiv.offsetWidth;
      setHeight(divWidth); // Assuming setHeight is a valid function in your context

      // Set the height to match the width (making it square)
      squareDiv.style.height = divWidth + 'px';
      console.log('Div width:', divWidth);
    });
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  window.addEventListener('load', function () {
    // setWidth(window.innerWidth);

    // Get all divs with the class name 'drop_box'
    const squareDivs = document.querySelectorAll('.drop_box');

    squareDivs.forEach((squareDiv) => {
      // Get the width of each div
      const divWidth = squareDiv.offsetWidth;
      setHeight(divWidth); // Assuming setHeight is a valid function in your context

      // Set the height to match the width (making it square)
      squareDiv.style.height = divWidth + 'px';
      console.log('Div width:', divWidth);
    });
  });

  const [isMobile, setIsMobile] = useState(true);

  // Check if the screen width is less than or equal to 768px (mobile size)
  const checkDevice = () => {
    setIsMobile(window.innerWidth <= 500); // You can adjust the width value as per your needs
  };

  useEffect(() => {
    checkDevice();
    window.addEventListener("resize", checkDevice);
    return () => {
      window.removeEventListener("resize", checkDevice);
    };
  }, []);


  return (
    <>
      {isMobile ? (
        <>
          <div className="main-page-body-content-header ">
            <HeaderAdmin />
          </div>
          <div className="dashboard-container d-flex camera-drop-box-fitting">
            <div className="main-container">
              <div className="main-page-body-content">
                <div className="main-page-body-content-body">
                  <div className="main-page-body-content-body-container">
                    <div className="container-fluid">
                      <div>
                        <div className="step-btn">
                          <div className="step-btn-item">
                            <button
                              className="btn step-btn-view step-left-btn"
                              disabled
                            >
                              <FaChevronLeft />
                              <div className="pr_content m-0 step_pr_content">
                                <h6>Step 1</h6>
                                <h4>Get Started</h4>
                              </div>
                            </button>
                          </div>
                          <div className="step-btn-item">
                            <button
                              className="btn step-btn-view step-right-btn"
                            >
                              <div className="pr_content m-0 step_pr_content text-right">
                                <h6>Step 3</h6>
                                <h4>Black Irons</h4>
                              </div>
                              <FaChevronRight />
                            </button>
                          </div>
                        </div>


                        <div className="step-content">
                          <div className="step-content-item step-content-item-active w-100 step-1">
                            <div className="step">
                              <div className="sec-header-dash white">
                                <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                  <h3>
                                    <span className="color"></span> White Irons
                                  </h3>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>

                        <div className="new-design-border-sec">
                          <div className="bg_color_dark">
                            <div className="row">
                              <div className="col-md-12">
                                <div className="justify-content-center">

                                  {/* Box 1 */}
                                  <div className="">
                                    <div className="sec-header-dash border-header-sec white">
                                      <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                        <h3 className="box-title-lable">
                                          <span className="color">1</span> White Iron
                                        </h3>
                                      </div>
                                    </div>
                                    <div className="desc">
                                      <p>Match up the club faces and upload a photo below with all three shots for us to analyze strike location.</p>
                                    </div>
                                    <div className="card-video" style={{ width: "100%" }}>
                                      <div className="drop_box" onClick={() => handleOpenModal(0)}>
                                        <input
                                          type="file"
                                          accept=".mp4,.avi,.mkv"
                                          id={`swing1.fileID`}
                                          style={{ display: 'none' }}
                                        />
                                        {
                                          photoInBox[0] && (
                                            <div className="form">
                                              <img
                                                className='uploaded-image'
                                                key={photoInBox[0]}
                                                src={photoInBox[0]}
                                                alt="selectedImage"
                                                style={{ width: '100%' }}
                                              />
                                            </div>
                                          )
                                        }
                                        <div className='custom-upload-btn'>
                                          <Form.Label className={`btn btn-colr-white w-100`}>
                                            Add photo
                                          </Form.Label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>





                        <div className="step-btn">
                          <div className="step-btn-item">
                            <button
                              className="btn step-btn-view step-left-btn"
                              disabled
                            >
                              <FaChevronLeft />
                              <div className="pr_content m-0 step_pr_content">
                                <h6>Step 1</h6>
                                <h4>Get Started</h4>
                              </div>
                            </button>
                          </div>
                          <div className="step-btn-item">
                            <button
                              className="btn step-btn-view step-right-btn"
                            >
                              <div className="pr_content m-0 step_pr_content text-right">
                                <h6>Step 3</h6>
                                <h4>Black Irons</h4>
                              </div>
                              <FaChevronRight />
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* Camera Modal */}
                      <CameraModal
                        show={showModal}
                        handleClose={handleCloseModal}
                        setPhotoInBox={updatePhotoInBox}
                      />
                    </div>
                  </div>
                </div>
              </div >
            </div >
          </div >
        </>
      ) : (
        <div style={errorStyle}>
          This app is only available on mobile devices.
        </div>
      )}
    </>
  );
};

const errorStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  textAlign: 'center',
  backgroundColor: '#98ea24',
  color: '#000000',
  padding: '20px',
  fontSize: '25px',
  fontWeight: 600
};


export default Camera;

